import { create } from "zustand";

export const useFilterStore = create((set) => ({
  filters: {
    vendorShortKey: null,
    customerNum: null,
    territory: null,
    specialDiscStatus:"All",
    commissionName: null,
    fromDate: null,
    toDate: null,
  },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
}));
